import router from './router';
import store from './store';

import NProgress from 'nprogress'; // progress bar
import '@/components/NProgress/nprogress.less'; // progress bar custom style
import { setDocumentTitle } from '@/utils/domUtil';
import { useRoleRouter } from '@/router/router.config';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = [
  'Root',
  'Index',
  'Project',
  'ContractCheck',
  'Zhejiang',
  'ZhejiangApply',
  'ContractCheck',
  'other',
  'Delogin',
  '404',
];
router.beforeEach(async (to, from, next) => {
  NProgress.start(); // start progress bar
  console.log(store.getters.getConfig.www_title);
  to.meta && to.meta.title !== 'undefined' && setDocumentTitle(store.getters.getConfig.www_title);
  if (store.getters.login) {
    let rroute = useRoleRouter();
    let nroute = rroute.find((e) => {
      return e.name == to.name;
    });
    if (nroute) {
      if (nroute.show) {
        next();
      } else {
        next({ path: '/404' });
      }
    } else {
      next();
    }
    NProgress.done();
    /* has token */
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next();
    } else {
      if (store)
        try {
          if (store.getters.getToken) {
            await store.dispatch('user/getUserInfoAction');
            if (store.getters.getConfig.is_header) {
              next({ path: '/admin/contract' });
            }
            next({ path: to.fullPath });
          } else {
            store.commit('user/SET_LOGINFLAG', true);

            next({ path: '/index' });
          }
        } catch {
          store.commit('user/SET_LOGINFLAG', true);
          next({ path: '/index' });
        }
      NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});
